export function getVerticalSpacing(spacing) {
    const spacings = {
        large: 'py-28  md:py-40 lg:py-56 xl:py-60 2xl:py-64',
        'large-no-top':
            'pt-6 pb-28 md:pt-10 md:pb-40 lg:pb-56 xl:pb-60 2xl:pb-64',
        'large-no-bottom':
            'pb-6 pt-28 md:pb-10 md:pt-40 lg:pt-56 xl:pt-60 2xl:pt-64',
        'large-medium-bottom':
            'pb-24 lg:pb-36 xl:pb-40 pt-28 md:pt-40 lg:pt-56 xl:pt-60 2xl:pt-64',
        'large-medium-top':
            'pt-24 lg:pt-36 xl:pt-40 pb-28 md:pb-40 lg:pb-56 xl:pb-60 2xl:pb-64',
        none: 'py-6 md:py-10',
        'no-top': 'pb-24 pt-6 md:pt-10 lg:pb-36',
        'no-bottom': 'pt-24 pb-6 md:pb-10 lg:pt-36',
        medium: 'py-24 lg:py-36 xl:py-40',
    };
    return spacings[spacing] || spacings.medium;
}

const HERO_PRESETS = {
    large: {
        topClass: 'pt-56 lg:pt-64',
        bottomClass: 'pb-36 lg:pb-28',
    },
    'large-no-top': {
        topClass: 'pt-36 lg:pt-40',
        bottomClass: 'pb-36 lg:pb-28',
    },
    'large-no-bottom': {
        topClass: 'pt-56 lg:pt-64',
        bottomClass: 'pb-10 lg:pb-0',
    },
    'large-medium-bottom': {
        topClass: 'pt-56 lg:pt-64',
        bottomClass: 'pb-24 lg:pb-10',
    },
    'large-medium-top': {
        topClass: 'pt-48 lg:pt-56',
        bottomClass: 'pb-36 lg:pb-28',
    },
    none: {
        topClass: 'pt-36 lg:pt-40',
        bottomClass: 'pb-10 lg:pb-0',
    },
    'no-top': {
        topClass: 'pt-36 lg:pt-40',
        bottomClass: 'pb-24 lg:pb-10',
    },
    'no-bottom': {
        topClass: 'pt-48 lg:pt-56',
        bottomClass: 'pb-10 lg:pb-0',
    },
    medium: {
        topClass: 'pt-48 lg:pt-56',
        bottomClass: 'pb-24 lg:pb-10',
    },
};

// Main hero spacing (more generous)
const MAIN_HERO_PRESETS = {
    large: {
        topClass: 'pt-64 lg:pt-96',
        bottomClass: 'pb-44 lg:pb-44',
    },
    'large-no-top': {
        topClass: 'pt-44 lg:pt-48',
        bottomClass: 'pb-44 lg:pb-44',
    },
    'large-no-bottom': {
        topClass: 'pt-64 lg:pt-96',
        bottomClass: 'pb-10',
    },
    'large-medium-bottom': {
        topClass: 'pt-64 lg:pt-96',
        bottomClass: 'pb-32 lg:pb-32',
    },
    'large-medium-top': {
        topClass: 'pt-56 lg:pt-64',
        bottomClass: 'pb-44 lg:pb-44',
    },

    none: {
        topClass: 'pt-44 lg:pt-48',
        bottomClass: 'pb-10 lg:pb-6',
    },
    'no-top': {
        topClass: 'pt-44 lg:pt-48',
        bottomClass: 'pb-32 lg:pb-32',
    },
    'no-bottom': {
        topClass: 'pt-56 lg:pt-64',
        bottomClass: 'pb-10 lg:pb-10',
    },
    medium: {
        topClass: 'pt-56 lg:pt-64',
        bottomClass: 'pb-32 lg:pb-32',
    },
};

export function getHeroVerticalSpacing(spacing) {
    const key = String(spacing || 'medium');
    const { topClass, bottomClass } = HERO_PRESETS[key] || HERO_PRESETS.medium;

    const className = `${topClass} ${bottomClass}`.trim();
    return { topClass, bottomClass, className };
}

export function getMainHeroVerticalSpacing(spacing) {
    const key = String(spacing || 'medium');
    const { topClass, bottomClass } =
        MAIN_HERO_PRESETS[key] || MAIN_HERO_PRESETS.medium;

    const className = `${topClass} ${bottomClass}`.trim();
    return { topClass, bottomClass, className };
}
